export default __webpack_public_path__ + "svg/calendar/2026/9/diciembre.svg?499745d9";